import { useEffect, useState } from "react";
import { brand, navigation } from "../siteContent";
import { NavLink } from "./NavLink";

export function SiteHeader({ navigate, path }) {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [path]);

  return (
    <header className="topbar">
      <NavLink to="/" className="brand" onNavigate={navigate} onClose={() => setMenuOpen(false)}>
        <img src={brand.logo} alt="Aspirant logo" className="brand-logo" />
        <span>
          <strong className="brand-title">
            Aspirant CSS
            <span className="brand-verified-badge" role="img" aria-label="Official Aspirant CSS website">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <circle cx="12" cy="12" r="11" />
                <path d="m7.4 12.2 3 3 6.4-6.6" />
              </svg>
            </span>
          </strong>
          <small>CSS, MPT & PMS prep</small>
        </span>
      </NavLink>
      <button
        type="button"
        className={`hamburger ${menuOpen ? "open" : ""}`}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((value) => !value)}
      >
        <span />
        <span />
        <span />
      </button>
      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        {navigation.map((item) => {
          const current = path === item.path || (
            item.path === "/css-syllabus" && /^\/css-[a-z-]+-syllabus$/.test(path)
          );
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`nav-link${item.path === "/css-syllabus" ? " nav-link-syllabus" : ""}${current ? " nav-link-current" : ""}`}
              ariaCurrent={path === item.path ? "page" : current ? "location" : undefined}
              onNavigate={navigate}
              onClose={() => setMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          );
        })}
      </nav>
    </header>
  );
}
